import {type PartialOptions, type UIElement, UI} from "../../../stem-core/ui/UIBase";
import {styleRule, StyleSheet, registerStyle} from "../../../stem-core/ui/Style";
import {LinkButton} from "../../../core/ui/LinkButton.jsx";
import {PAGES, type NavPage} from "./Nav.jsx";
import {CloseIcon} from "../../../core/ui/SVGElements.jsx";

export class NavMobileExpandedStyle extends StyleSheet {
    @styleRule
    scrim = {
        background: "rgba(255,255,255,.84)",
        transition: this.themeProps.DEFAULT_TRANSITION_DURATION_MS,
        position: "fixed",
        zIndex: 10000,
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        opacity: 0,
    };

    @styleRule
    links = {
        ">*": {
            fontSize: 18,
            color: this.themeProps.NAVBAR_CENTER_ITEM_ACTIVE + " !important",
            fontWeight: "normal",
            width: "100%",
            height: 56,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        transition: this.themeProps.DEFAULT_TRANSITION,
        transitionDelay: this.themeProps.DEFAULT_TRANSITION_DURATION_MS + "ms",
        flex: 1,
        opacity: 0,
    };

    @styleRule
    nav = {
        padding: "0 12px",
        display: "flex",
        width: "100%",
        position: "fixed",
        background: this.themeProps.NAVBAR_BACKGROUND,
        top: 0,
        zIndex: 10002,
        transform: "translateY(-208px)",
        opacity: 1,
        transition: this.themeProps.DEFAULT_TRANSITION,
        boxShadow: this.themeProps.NAV_MOBILE_SHADOW,
    };

    @styleRule
    visible = {
        ">*": {
            opacity: 1,
        },
        ">*>*": {
            opacity: 1,
        },
        ">:first-child": {
            transform: "translateY(0) scale(1)",
        },
    };

    @styleRule
    close = {
        color: this.themeProps.NAVBAR_CENTER_ITEM_ACTIVE,
        alignSelf: "start",
        position: "fixed",
        top: 20,
        left: 12,
        cursor: "pointer",
        zIndex: 10003,
        transition: this.themeProps.DEFAULT_TRANSITION,
        transitionDelay: this.themeProps.DEFAULT_TRANSITION_DURATION_MS + "ms",
        opacity: "0",
    };
}

interface NavMobileExpandedOptions {
    currentActivePage?: NavPage;
}

// This needs refactoring. We also need to rethink the animation.
@registerStyle(NavMobileExpandedStyle)
export class NavMobileExpanded extends UI.Element<NavMobileExpandedOptions> {
    declare links?: UIElement;
    static show(options: PartialOptions<NavMobileExpanded>) {
        this.create(document.body, options);
    }

    render() {
        const {styleSheet} = this;
        const items = PAGES.filter(page => !page.Icon);

        return [
            <div className={styleSheet.nav}>
                <div className={styleSheet.links} ref="links">
                    {items.map(page => (
                        <LinkButton href={page.href} value={page.title} onClick={() => this.hide(page)} />
                    ))}
                </div>
            </div>,
            <div className={styleSheet.scrim} onClick={() => this.hide()} />,
            <CloseIcon ref="closeIcon" size={18} color="white" className={styleSheet.close} onClick={() => this.hide()} />,
        ];
    }

    hide(page?: NavPage): void {
        if (page) {
            this.updateOptions({currentActivePage: page});
        }

        this.attachTimeout(() => {
            this.links.setStyle("transitionDelay", "0s");
            this.removeClass(this.styleSheet.visible);
        }, 0);

        this.attachTimeout(() => this.destroyNode(), this.themeProps.DEFAULT_TRANSITION_DURATION_MS);
    }

    onMount() {
        this.attachTimeout(() => {
            this.addClass(this.styleSheet.visible);
        }, 100);
    }
}
